import React from 'react'

const ReportItems = ({report}) => {
  return (
    <div className="text-sm grid grid-cols-6 px-5 space-x-2 py-2 my-2 mx-1 rounded-sm bg-[#434242] text-white">
      <p className="col-span-2 truncate text-xs">
        {report.title}
      </p>
      <p className="col-span-3 truncate text-xs">{report.des}</p>
      <p className="col-span-1 truncate text-xs">{report.date}</p>
      
    </div>
  );
}

export default ReportItems